<!-- 轻量化监控表格 -->
<template>
  <div v-loading="loading" class="lightTable" element-loading-text="数据加载中">
    <el-table class="tableList" :data="tableData" :border="true" height="100%" highlight-current-row @filter-change="getFilterData">
      <el-table-column label="文件名称" prop="fileName" fixed min-width="120" />
      <el-table-column label="文件大小" prop="fileSize" width="90">
        <template #default="{ row }">
          {{ row.fileSize }}
        </template>
      </el-table-column>
      <el-table-column label="文件ID" prop="fileId" width="150" />
      <el-table-column label="轻量化状态" prop="status" column-key="statusList" align="center" :filters="statusList" width="120">
        <template #default="{ row }">
          <span v-if="row.status == 30" class="status status1">排队中</span>
          <span v-if="row.status == 31" class="status status2">转换中</span>
          <span v-if="row.status == 41" class="status status3">成功</span>
          <span v-if="row.status == 42" class="status status4">失败</span>
        </template>
      </el-table-column>
      <el-table-column label="排队时长" prop="lineUpTime" width="120" />
      <el-table-column label="轻量化时长" prop="convertTime" width="120" />
      <el-table-column label="问题原因" prop="remark" min-width="120" />
      <el-table-column label="上传人" prop="checkInUser" width="90" />
      <el-table-column label="上传路径" prop="position" width="160" />
      <el-table-column label="上传时间" prop="createTime" width="160" />
      <el-table-column label="轻量化服务器IP" prop="serverIp" width="120" />
      <el-table-column label="轻量化开始时间" prop="startDate" width="160" />
      <el-table-column label="轻量化完成时间" prop="endDate" width="160" />
      <el-table-column label="操作" align="center" width="100">
        <template v-slot="{ row }">
          <div v-loading="row.loading" class="btnBox">
            <span v-if="row.status === 30" class="btn" @click="precedence(row)">优先</span>
            <span class="btn" @click="down(row)">下载</span>
            <span v-if="row.status !== 30" class="btn" @click="retry(row)">重试</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <page class="pageBottom" :page="page" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></page>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { downloadUrltoken, downloadFile } from "@/CommonDP/utils";
import page from "@/CommonDP/components/paging";
import lightService from "@/CommonDP/service/light-service";

export default {
  components: { page },
  props: {
    searchForm: {
      type: Object,
      default: () => ({})
    } // 筛选表单
  },
  data() {
    return {
      loading: false,
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 0
      },
      statusList: [
        { value: 30, text: "排队中" },
        { value: 31, text: "转换中" },
        { value: 41, text: "成功" },
        { value: 42, text: "失败" }
      ], // 筛选状态
      filters: {
        statusList: []
      }
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    // 加载数据
    async getTableData() {
      this.loading = true;
      try {
        const { pageNo, pageSize } = this.page;
        const params = {
          ...this.searchForm,
          ...this.filters,
          pageNum: pageNo,
          pageSize: pageSize
        };
        const { data, totalCount } = await lightService.getList(params);
        this.tableData = data || [];
        this.page.totalCount = totalCount || 0;
      } finally {
        this.loading = false;
      }
    },
    // 查询
    search() {
      this.page.pageNo = 1;
      this.getTableData();
    },
    // 切换分页大小
    handleSizeChange(size) {
      this.page.pageSize = size;
      this.search();
    },
    // 切换分页
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getTableData();
    },
    // 筛选条件
    getFilterData(col) {
      for (const key in col) {
        if (col[key] && col[key].length) this.filters[key] = col[key];
        else this.filters[key] = [];
      }
      this.search();
    },

    // 优先
    async precedence(row) {
      this.$set(row, "loading", true);
      try {
        const { convertTaskId } = row;
        await lightService.precedence(convertTaskId);
        this.$message.success("请求成功");
        this.getTableData();
      } finally {
        this.$set(row, "loading", false);
      }
    },
    // 下载
    down(row) {
      const { prjId, fileId } = row;
      const url = downloadUrltoken(prjId, fileId);
      downloadFile(url);
    },
    // 重试轻量化
    async retry(row) {
      this.$set(row, "loading", true);
      try {
        const { prjId, fileId, fileVersion } = row;
        await lightService.resetAgain(prjId, fileId, fileVersion);
        this.$message.success("请求成功");
        this.getTableData();
      } finally {
        this.$set(row, "loading", false);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.lightTable {
  width: 100%;
  height: 100%;
  padding-top: 20px;
  display: flex;
  flex-direction: column;

  .pageBottom {
    padding: var(--middle-space) 0;
    text-align: right;
  }
}
::v-deep .tableList {
  width: 100%;
  height: 1px;
  flex-grow: 1;
  .el-table__header {
    .el-table__cell {
      height: 50px;
      padding: 0px;
      background-color: #f7f9ff;
      color: var(--key-color);
    }
  }
}

.btnBox {
  display: flex;
  justify-content: space-around;
  .btn {
    color: #3791fb;
    cursor: pointer;
  }
}

.status {
  display: inline-block;
  padding: 0px 8px;
  border-radius: 15px;
}
.status1 {
  color: #3791fb;
  background-color: #9dc9fc;
}
.status2 {
  color: #f5ca44;
  background-color: #fde6a2;
}
.status3 {
  color: #56ca77;
  background-color: #d4ffe0;
}
.status4 {
  color: #fa5f87;
  background-color: #fde0df;
}
</style>
